import { render, staticRenderFns } from "./formInspeccionPallet.vue?vue&type=template&id=129d5bf6"
import script from "./formInspeccionPallet.vue?vue&type=script&lang=js"
export * from "./formInspeccionPallet.vue?vue&type=script&lang=js"
import style0 from "./formInspeccionPallet.vue?vue&type=style&index=0&id=129d5bf6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports